import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { Link } from 'react-router-dom';

import { RIGHTS_CHAINS, RIGHTS_IS_CREATE, TABLET } from '@app/constants';
import { useAccessRights, useWindowSize } from '@app/hooks';

export const ChainsPageHeader = () => {
  const { innerWidth } = useWindowSize();
  const { hasUserRight } = useAccessRights(RIGHTS_CHAINS, RIGHTS_IS_CREATE);

  const label = innerWidth <= TABLET ? '' : 'Добавить сеть';

  if (!hasUserRight) {
    return <></>;
  }

  return (
    <Link to="/chains/add/">
      <Button type="primary" icon={<PlusOutlined />} data-testid="add-chain">
        {label}
      </Button>
    </Link>
  );
};
